import { createBrowserRouter } from 'react-router-dom';

import MainComponent, { loader as MainComponentLoader } from '../components/MainComponent';
import LoginComponent from '../components/LoginComponent';
import SearchComponent from '../components/SearchComponent';
import DirectAuthorization from '../components/DirectAuthorization';
import MainCategoriesComponent from '../components/MainCategoriesComponent';
import DownloadComponent from '../components/DownloadComponent';
import LanguageComponent from '../components/LanguageComponent';
import CategoryComponent from '../components/CategoryComponent';
import ItemDetailsComponent from '../components/ItemDetailsComponent';
import SingleBookComponent from '../components/SingleBookComponent';
import ResetPasswordComponent from '../components/ResetPasswordComponent';

export const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <MainComponent />,
      children: [

        {
          index: true,
          element: <MainCategoriesComponent />,
          loader: MainComponentLoader
        },
        {
          path: "/download/:id",
          element: <DownloadComponent />,
        },
        {
          path: '/authorization',
          element: <LoginComponent />
        },
        {
          path: '/reset-password',
          element: <ResetPasswordComponent />
        },
        {
          path: '/search',
          element: <SearchComponent />
        },
        {
          path: "/:language",
          element: <LanguageComponent />,
        },
        {
          path: "/:language/:category",
          element: <CategoryComponent />
        },
        {
          path: "/:language/:category/:slug",
          element: <ItemDetailsComponent />
        },
        {
          path: "/single-book/:language/:slug",
          element: <SingleBookComponent />
        },



      ]
    },

    {
      path: '/direct-authorization/:id',
      element: <DirectAuthorization />
    }

  ]
);
